const nl = {
  'shipping-and-delivery': { title: 'Verzending en levering', urlSlug: 'verzending-en-levering' },
  'watch-service': { title: 'Horloge service', urlSlug: 'horloge-service' },
  'jewel-service': { title: 'Juwelen service', urlSlug: 'juwelen-service' },
  'return-and-refund': { title: 'Retour en terugbetaling', urlSlug: 'retour-en-terugbetaling' },
  payments: { title: 'Betalen', urlSlug: 'betalen' },
  stores: { title: 'Vestigingen', urlSlug: 'vestigingen' },
  moreQuestions: 'Meer vragen',
}

export type FaqMessages = typeof nl

export default nl
